import { lazy } from 'react';

import { LayoutType, PageType } from '@shared/constants/constants';
import { ACTION_BACK_PATH, LAB_TEST_RESULTS_DETAILS_PATH, LAB_TEST_RESULTS_PATH } from '@shared/constants/paths';
import { SERVICE_CATALOG_CODE } from '@shared/constants/serviceCatalog';
import type { RouteConfig } from '@shared/types/common.types';

const LabResultPage = lazy(() => import('@features/HealthRecords/TestReports/LabResult'));
const LabResultDetailPage = lazy(() => import('@features/HealthRecords/TestReports/LabResult/LabResultDetailPage'));

export const LAB_TEST_RESULT_ROUTES: RouteConfig[] = [
  {
    actionUrl: ACTION_BACK_PATH,
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <LabResultPage />,
    displayTitle: () => 'Lab Reports',
    pageType: PageType.PRIVATE,
    path: LAB_TEST_RESULTS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.labReports,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <LabResultDetailPage />,
    displayTitle: () => 'Lab Report Details',
    pageType: PageType.PRIVATE,
    path: LAB_TEST_RESULTS_DETAILS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.labReports,
  },
];
